import {Base} from '../core/base.model';

export class ProgramacionTarea extends Base {

    id: number;
    idUsuario: number;
    idTarea: number;

    esPausaConsiderada: boolean;

    duracionTarea: number;
    inicioTarea: Date;
    inicioPausa: Date;
    duracionPausa: number;

}
